import type TransactionStatus from "enums/TransactionStatus";

/** One row of a recent-transactions list, already resolved and formatted. */
export interface TransactionRow {
  id: string;
  merchant: string;
  /** Brandfetch sources for the mark; absent means fall back to a lettermark. */
  url?: string;
  logo?: string;
  cachedLogo?: string;
  /** Already formatted and localised, e.g. "-$142.19". */
  amount: string;
  /** Epoch ms, used for the row's date and for grouping. */
  date?: number | null;
  cardNumber?: string | null;
  /** Who spent it. Only listed where the reader is not the cardholder. */
  spender?: string;
  status?: TransactionStatus | null;
  policyStatus?: unknown;
  policyStatusDisplay?: unknown;
}

/** The merchant a list shows: the enriched name, else the card network's descriptor. */
export const transactionMerchantName = (transaction: {
  merchant?: string | null;
  merchantData?: { name?: string | null } | null;
}): string =>
  transaction.merchantData?.name?.trim() || transaction.merchant || "";

const SEPARATOR = " · ";

/**
 * The quieter second line. Parts that are absent drop out, so an admin list
 * naming the spender and a personal list omitting them are the same line with
 * one fewer part rather than two formats.
 */
export const transactionMeta = (parts: (string | null | undefined)[]): string =>
  parts.filter(Boolean).join(SEPARATOR);
